module.exports = __webpack_public_path__ + "static/media/5.Pneumatic Tools.0421a6fc.jpg";